import { Card } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../../components/Forms/PrimaryButton";
import CustomBadge from "../../components/Charts/CustomBadge";
import { useApiCall } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { calcInStock, formatDate, getStockStatus, handleRouteNav, numberFormatter } from "../../utils";
import NewOfferModal from "../../components/models/NewOfferModal";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { setOfferShown } from "../../redux/auth/loginSlice";
import { setOfferList } from "../../redux/auth/navCountSlice";
import ViewBrochureModal from "../../components/models/ViewBrochureModal";

const HomePage = () => {
  const navigate = useNavigate();
  const { showPopup } = useGlobalModal();
  const { getApi, postApi, loading } = useApiCall();
  const { customer_id, role_id, offer_shown, is_customer, is_agree_terms } = useSelector((state) => state.auth);
  const [bestSellerProducts, setBestSellerProducts] = useState([]);
  const [newlyAddedProducts, setNewlyAddedProducts] = useState([]);

  const [categories, setCategories] = useState([]);
  const [allBrochures, setAllBrochures] = useState([]);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [viewRecord, setViewRecord] = useState(null);

  const [bannerDetails, setBannerDetails] = useState([]);
  const { offerList = [] } = useSelector((state) => state.navCounts);
  const [isNewOfferModal, setIsNewOfferModal] = useState();
  const [schemeData, setSchemeData] = useState([]);
  const dispatch = useDispatch();

  const toggleFav = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setNewlyAddedProducts((prev) =>
      prev.map((item, i) => {
        if (i === index) {
          const isCurrentlyFav = item?.product?.wishlist_tag === "yes";

          return {
            ...item,
            product: {
              ...item.product,
              wishlist_tag: isCurrentlyFav ? "no" : "yes",
            },
          };
        }
        return item;
      }),
    );
    const item = newlyAddedProducts[index];
    if (item?.product?.wishlist_tag === "yes") {
      rmoveWishlistItem(item);
    } else {
      addWishlistItem(item);
    }
  };

  const toggleFavbestSeller = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setBestSellerProducts((prev) =>
      prev.map((item, i) => {
        if (i === index) {
          const isCurrentlyFav = item?.product?.wishlist_tag === "yes";

          return {
            ...item,
            product: {
              ...item.product,
              wishlist_tag: isCurrentlyFav ? "no" : "yes",
            },
          };
        }
        return item;
      }),
    );
    const item = bestSellerProducts[index];
    if (item?.product?.wishlist_tag === "yes") {
      rmoveWishlistItem(item);
    } else {
      addWishlistItem(item);
    }
  };

  const addWishlistItem = async (item) => {
    const payload = {
      customer_id: customer_id,
      product_id: item?.product?.product_id,
      sort_no: item?.product?.sort_no,
    };
    const res = await postApi("wishlist/add-wishlist", payload);
  };

  const rmoveWishlistItem = async (item) => {
    const payload = {
      customer_id: customer_id,
      product_id: item?.product?.product_id,
      sort_no: item?.product?.sort_no,
    };
    const res = await postApi("wishlist/delete-wishlist-product", payload);
  };

  const fetchProductList = async () => {
    const payload = {
      customer_id: customer_id,
    };
    const res = await postApi("product/newly", payload);
    if (res && res.data) {
      setNewlyAddedProducts(res.data);
    }
  };

  const fetchBestSellerProductList = async () => {
    const payload = {
      customer_id: customer_id,
    };
    const res = await postApi("product/best-seller", payload);
    if (res && res.data) {
      setBestSellerProducts(res.data);
    }
  };

  const fetchCategory = async () => {
    const res = await postApi("category", {});
    if (res?.data) {
      const baseSorted = [...res.data].sort((a, b) => b.category_id - a.category_id);

      const centerItem = baseSorted.find((item) => item.category_id === 1);
      const remaining = baseSorted.filter((item) => item.category_id !== 1);

      if (centerItem) {
        const midPoint = Math.ceil(remaining.length / 2);
        const rightWing = remaining.slice(0, midPoint);
        const leftWing = remaining.slice(midPoint);

        setCategories([...leftWing, centerItem, ...rightWing]);
      } else {
        setCategories(baseSorted);
      }
    }
  };

  const fetchBrochures = async () => {
    try {
      const response = await getApi("sales/brochure/list");
      const formatted = (response.data || [])
        .map((item, index) => ({
          ...item,
          status: item.status === "Active" ? "Active" : "Disabled",
          key: index + 1,
        }))
        .filter((b) => b.status === "Active");
      setAllBrochures(formatted);
    } catch (error) {
      console.error(error);
    }
  };

  const redirect = (type) => {
    navigate("/home/" + type);
  };

  const redirectOnProductByFilter = (item) => {
    navigate("/home/category/" + item?.category_clienttype);
  };

  const handleRowClick = (record) => {
    navigate(handleRouteNav(`/product-details/${record.sort_no}`));
  };

  const getBanner = async () => {
    const res = await getApi("banner/get-banner");
    if (res) {
      const bannerData = res?.data.find((item) => item?.banner_for == "web");
      setBannerDetails(bannerData);
    }
  };

  useEffect(() => {
    getBanner();
    fetchProductList();
    fetchBestSellerProductList();
    fetchCategory();
    fetchBrochures();
  }, []);

  const offerIds = offerList?.map((offer) => offer.offer_id).join(",");

  useEffect(() => {
    if (is_customer && is_agree_terms == 0) {
      dispatch(setOfferShown());
      return;
    }
    if (offerList?.length > 0 && !offer_shown) {
      const applicableOffers = offerList.filter((offer) => {
        if (["Inactive", "Expired"].includes(offer?.status)) return false;
        try {
          const customer_ids = JSON.parse(offer?.customer_ids || "[]");
          return customer_ids.includes(Number(customer_id));
        } catch (error) {
          return false;
        }
      });

      if (applicableOffers.length === 0) return;

      const randomIndex = Math.floor(Math.random() * applicableOffers.length);
      openModal(applicableOffers[randomIndex]?.offer_id);
    }
  }, [offerIds]);

  const scrollRef = useRef(null);
  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const mouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const mouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const mouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // speed
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", mouseDown);
    slider.addEventListener("mouseleave", mouseLeave);
    slider.addEventListener("mouseup", mouseUp);
    slider.addEventListener("mousemove", mouseMove);

    return () => {
      slider.removeEventListener("mousedown", mouseDown);
      slider.removeEventListener("mouseleave", mouseLeave);
      slider.removeEventListener("mouseup", mouseUp);
      slider.removeEventListener("mousemove", mouseMove);
    };
  }, []);

  const openModal = async (scheme_id) => {
    if (!scheme_id) return;
    const payload = {
      customer_id: customer_id,
      offer_id: scheme_id,
    };

    const res = await postApi("offer/get-detail", payload);

    if (res && res.data) {
      setSchemeData(res.data);
      setIsNewOfferModal(true);
      dispatch(setOfferShown());
    }
  };

  const getOfferList = async () => {
    const payload = {
      customer_id: customer_id,
    };
    const res = await postApi("offer/list", payload);
    if (res) {
      dispatch(setOfferList(res?.data || []));
    } else {
      dispatch(setOfferList([]));
    }
  };

  useEffect(() => {
    getOfferList();
  }, []);

  return (
    <>
      <div className="px-10 md:px-20 lg:px-32 pb-6">
        <div className="w-full relative pb-10">
          <Title className="font-abhaya text-start !text-[48px] !max-w-[65%] !text-[#484848] !font-[400]">{bannerDetails?.big_title}</Title>
          <Paragraph className="text-start absolute right-0 bottom-0 font-sans text-[16px] !text-[#484848] !max-w-96">
            {bannerDetails?.small_title}
          </Paragraph>
        </div>

        <Card
          className="rounded-xl overflow-hidden h-[250px] bg-white"
          styles={{ body: { padding: 0 } }}
          cover={
            <div className="h-[250px]">
              <img alt="product" src={bannerDetails?.banner_picture_url} className="w-full h-full object-cover block" />
            </div>
          }
        />

        {/* Newly added products */}
        <div className="mt-10 flex flex-col gap-4">
          <div className="w-full flex flex-wrap justify-between items-center ">
            <Title level={1} className="font-abhaya !mb-0 !font-[400]">
              Now Trending
            </Title>
            <PrimaryButton
              className="mr-[42px]"
              onClick={() => {
                redirect("now-trending");
              }}
              text="View all"
            />
          </div>
          {/* Cards */}
          <div ref={scrollRef} className="overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing">
            <div className="grid grid-flow-col auto-cols-[300px] gap-5 pb-6">
              {newlyAddedProducts.slice(0, 10).map((item, i) => {
                const { key, text, variant } = getStockStatus(item.quality_shade);
                return (
                  <Card
                    key={i}
                    hoverable
                    variant="outlined"
                    style={{
                      borderRadius: 14,
                      overflow: "hidden",
                    }}
                    onClick={() => handleRowClick(item)}
                    cover={
                      <div style={{ position: "relative" }}>
                        <div className="p-3">
                          <img src={item?.product?.product_pic_url} alt={item.short_name} className="rounded-xl w-full h-48 object-cover" />
                        </div>

                        {/* Status Pill */}
                        <div
                          style={{
                            position: "absolute",
                            top: 24,
                            left: 24,
                          }}
                        >
                          <CustomBadge
                            customColors={{
                              bgColor: "#00000066",
                              textColor: "#fff",
                            }}
                            variant={variant}
                            text={text}
                          />
                        </div>

                        {/* Favorite Icon */}
                        <div
                          onClick={(e) => toggleFav(e, i)}
                          style={{
                            position: "absolute",
                            top: 24,
                            right: 24,
                            width: 36,
                            height: 36,
                            borderRadius: "10px",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                          }}
                          className="border border-transparent hover:border-[#A33434] transition-all duration-200"
                        >
                          {item?.product?.wishlist_tag == "yes" ? (
                            <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                                fill="#A33434"
                              />
                            </svg>
                          ) : (
                            <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                opacity="0.1"
                                d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    }
                  >
                    {/* Bottom Card Content */}
                    <div className="flex justify-between mb-2">
                      <div className="text-start">
                        <div className="font-semibold text-base">{item.short_name}</div>
                        <div className="text-gray-500 text-sm text-left">{item.clienttype}</div>
                      </div>

                      <div className="text-base text-gray-600">{item.finish_width}''</div>
                    </div>

                    {/* <div className="flex items-baseline gap-2">
                  <div className="text-xl font-bold">₹{item.rate}</div>
                  <div className="text-gray-500 text-sm">/ meter</div>
                </div> */}
                  </Card>
                );
              })}
            </div>
          </div>
        </div>

        {/* Categories */}
        <div className="mt-10 flex flex-col gap-4 w-full">
          <Title className="!text-[48px] font-abhaya lg:max-w-[70%] mx-auto !font-[400]">
            From every day to exclusive, 500+ fabrics for all sectors.
          </Title>
          <div className="flex items-center justify-center gap-5">
            {categories.map((item, i) => (
              <div
                className="flex flex-col items-center justify-center gap-3"
                onClick={() => {
                  redirectOnProductByFilter(item);
                }}
              >
                <img
                  className="rounded-full h-32 w-32 object-cover cursor-pointer transition-all transform hover:scale-110"
                  src={item.category_picture_url}
                />
                <Title className="!font-[400]" level={4}>
                  {item.category_clienttype}
                </Title>
              </div>
            ))}
          </div>
        </div>

        {/* Best Selling products */}
        <div className="mt-10 flex flex-col gap-4">
          <div className="w-full flex flex-wrap justify-between items-center ">
            <Title level={1} className="font-abhaya !mb-0 !font-[400]">
              Top selling
            </Title>
            <PrimaryButton
              className="mr-[42px]"
              onClick={() => {
                redirect("top-selling");
              }}
              text="View all"
            />
          </div>
          {/* Cards */}
          <div ref={scrollRef} className="overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing">
            <div className="grid grid-flow-col auto-cols-[300px] gap-5 pb-6">
              {bestSellerProducts.slice(0, 10).map((item, i) => {
                const { key, text, variant } = getStockStatus(item.quality_shade);
                return (
                  <Card
                    key={i}
                    hoverable
                    variant="outlined"
                    style={{
                      borderRadius: 14,
                      overflow: "hidden",
                    }}
                    onClick={() => handleRowClick(item)}
                    cover={
                      <div style={{ position: "relative" }}>
                        <div className="p-3">
                          <img src={item?.product?.product_pic_url} alt={item.short_name} className="rounded-xl w-full h-48 object-cover" />
                        </div>

                        {/* Status Pill */}
                        <div
                          style={{
                            position: "absolute",
                            top: 24,
                            left: 24,
                          }}
                        >
                          <CustomBadge
                            dotClassName="mr-3"
                            customColors={{
                              bgColor: "#00000066",
                              textColor: "#fff",
                            }}
                            variant={variant}
                            text={text}
                          />
                        </div>

                        {/* Favorite Icon */}
                        <div
                          onClick={(e) => toggleFavbestSeller(e, i)}
                          style={{
                            position: "absolute",
                            top: 24,
                            right: 24,
                            width: 36,
                            height: 36,
                            borderRadius: "10px",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                          }}
                          className="border border-transparent hover:border-[#A33434] transition-all duration-200"
                        >
                          {item?.product?.wishlist_tag == "yes" ? (
                            <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                                fill="#A33434"
                              />
                            </svg>
                          ) : (
                            <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                opacity="0.1"
                                d="M21 5.8125C21 12.375 11.2697 17.6869 10.8553 17.9062C10.7461 17.965 10.624 17.9958 10.5 17.9958C10.376 17.9958 10.2539 17.965 10.1447 17.9062C9.73031 17.6869 0 12.375 0 5.8125C0.00173694 4.27146 0.614681 2.79404 1.70436 1.70436C2.79404 0.614681 4.27146 0.00173694 5.8125 0C7.74844 0 9.44344 0.8325 10.5 2.23969C11.5566 0.8325 13.2516 0 15.1875 0C16.7285 0.00173694 18.206 0.614681 19.2956 1.70436C20.3853 2.79404 20.9983 4.27146 21 5.8125Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    }
                  >
                    {/* Bottom Card Content */}
                    <div className="flex justify-between mb-2">
                      <div className="text-start">
                        <div className="font-semibold text-base">{item.short_name}</div>
                        <div className="text-gray-500 text-sm text-left">{item.clienttype}</div>
                      </div>

                      <div className="text-base text-gray-600">{item.finish_width}''</div>
                    </div>

                    {/* <div className="flex items-baseline gap-2">
                    <div className="text-xl font-bold">₹{item.rate}</div>
                    <div className="text-gray-500 text-sm">/ meter</div>
                  </div> */}
                  </Card>
                );
              })}
            </div>
          </div>
        </div>

        {/* Brochures */}
        {allBrochures?.length > 0 && (
          <div className="mt-10 flex flex-col w-full gap-4">
            <div className="w-full flex flex-wrap justify-between items-center">
              <Title level={1} className="font-abhaya !mb-0">
                Brochures
              </Title>
            </div>
            <div className="flex items-center gap-5 overflow-x-auto no-scrollbar p-2">
              {allBrochures.map((item, i) => (
                <div
                  key={i}
                  className="flex flex-col items-center justify-center gap-3 shrink-0"
                  onClick={() => {
                    setViewRecord(item);
                    setIsViewOpen(true);
                  }}
                >
                  <div className="w-48 aspect-[595/842] relative group">
                    <img
                      className="w-full h-full object-cover cursor-pointer transition-all duration-300 transform group-hover:scale-105 border border-gray-100"
                      src={item.brochure_picture_url}
                      alt={item.name}
                    />
                  </div>
                  <Title className="!font-[400] truncate max-w-[180px] !m-0 pt-2 text-center" level={4} title={item.name}>
                    {item.name}
                  </Title>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Schemes & Offers */}
        {offerList?.length > 0 && (
          <div className="mt-10 flex flex-col gap-4">
            <div className="w-full flex flex-wrap justify-between items-center ">
              <Title level={1} className="font-abhaya !mb-0">
                Schemes & Offers
              </Title>
            </div>

            <div ref={scrollRef} className="overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing">
              <div className="grid grid-flow-col auto-cols-[500px] gap-5 py-4 px-2">
                {offerList?.length > 0 &&
                  [...offerList]
                    .sort((a, b) => {
                      const dateA = a?.to_date ? new Date(a.to_date).getTime() : 0;
                      const dateB = b?.to_date ? new Date(b.to_date).getTime() : 0;
                      return dateA - dateB;
                    })
                    .map((item) => {
                      const sortedVariantSummary =
                        [...(item?.variants || [])]?.sort((a, b) => +a?.variant_qty - +b?.variant_qty).map((a, i) => ({ ...a, index: i + 1 })) || [];
                      let currentVariantSummary = sortedVariantSummary?.[sortedVariantSummary?.length - 1] || {};

                      return (
                        <div
                          onClick={() =>
                            navigate(handleRouteNav(`/home/scheme-details`, role_id), {
                              state: { offerId: item?.offer_id },
                            })
                          }
                          className="cursor-pointer bg-offer h-[228px] relative px-[20px] py-[10px] bg-[#A33434] text-white rounded-3xl overflow-hidden flex transition-all duration-300 hover:-translate-y-1 active:translate-y-0"
                        >
                          <div
                            className="absolute
                            left-[90px]
                            top-[-79px]
                            w-[91px]
                            h-[91px]
                            bg-[#f5f5f5]
                            z-[9] rounded-full"
                          ></div>
                          <div className="flex items-center justify-center">
                            <div className="vertical-text text-[28px] font-bold">
                              {currentVariantSummary?.variant_incentive} {item?.credit_type == "percentage" ? "%" : "₹/m"}
                              <p>OFF</p>
                            </div>
                          </div>

                          <div className="relative w-[2px] bg-transparent">
                            <div className="absolute inset-y-3 left-[30px] border-l-2 border-dashed border-[#7F2626]"></div>
                          </div>

                          <div className="flex-1 max-w-[380px] px-4 pl-[40px] flex flex-col justify-between">
                            <div className="text-right text-[16px] text-[#fff]">
                              *Valid till{" "}
                              {formatDate(item?.to_date, {
                                format: "DD MMM YYYY",
                              })}
                            </div>

                            <div
                              className="font-semibold text-[24px] text-left ml-5 leading-normal line-clamp-2 [text-wrap:balance] [overflow-wrap:anywhere] overflow-hidden"
                              title={item?.title}
                            >
                              {item?.title}
                            </div>

                            <div className="text-right text-[20px] mt-2 font-medium">
                              {numberFormatter(currentVariantSummary?.variant_qty)} {item?.qty_type === "Cases" ? "Cases" : "Meters"}
                            </div>
                          </div>

                          <div
                            className="absolute
                            left-[90px]
                            bottom-[-79px]
                            w-[91px]
                            h-[91px]
                            bg-[#f5f5f5]
                            z-[9] rounded-full"
                          ></div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        )}
      </div>
      <NewOfferModal schemeData={schemeData} open={isNewOfferModal} onClose={() => setIsNewOfferModal(false)}></NewOfferModal>

      <ViewBrochureModal isOpen={isViewOpen} closeModal={() => setIsViewOpen(false)} data={viewRecord} />
    </>
  );
};

export default HomePage;
